import React, {Component} from 'react';
import t from 'tcomb-form';
import classNames from 'classnames';

export default class FormCheckbox extends Component {
    static displayName = 'FormCheckbox';

    constructor(props) {
        super(props);
        this.state = {
            value: props.value || false,
            id: props.ctx.uidGenerator.next()
        };
    }

    UNSAFE_componentWillReceiveProps(props) {
        if (props.value !== undefined) {
            this.setState({value: props.value});
        }
    }

    handleChange = e => {
        const value = e.target.checked;

        this.setState({value}, () => {
            this.props.onChange(value, this.props.ctx.path);
        });
    };

    getValidationOptions() {
        return {
            path: this.props.ctx.path,
            context: t.mixin(t.mixin({}, this.props.context || this.props.ctx.context), {
                options: this.props.options
            })
        };
    }

    validate() {
        const value = this.state.value;
        const result = t.validate(value, this.props.type, this.getValidationOptions());
        this.setState({hasError: !result.isValid()});
        return result;
    }

    render() {
        const label = this.props.options.label || this.props.ctx.label;
        const {header} = this.props.options;

        const {id, value, hasError} = this.state;
        return (
            <div className={classNames('form-group', hasError && 'has-error')}>
                {header && <label className="control-label">{header}</label>}
                <div className="checkbox">
                    <label htmlFor={id} className="control-label">
                        <input
                            className="form-checkbox"
                            id={id}
                            type="checkbox"
                            checked={value}
                            onChange={this.handleChange}
                        />
                        <span className="actual-checkbox" />
                        {label}
                    </label>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./form_components/form_checkbox.js